import app from "./general/js/app";

// Loaded after app.js
require("./screens/register.js");
require("./screens/login.js");

require("./custom.js");

require("./custom/bootstrap.js");
require("./custom/forms.js");
require("./custom/header.js");
require("./custom/lang.js");
require("./custom/menu.js");
require("./custom/scroll.js");
require("./custom/search.js");
require("./custom/accessible-toggle.js");
require("./custom/lvl-filter.js");
require("./custom/components/video-modal");
require("./custom/components/accordion-opener");
require("./custom/components/infinite-scroll");
require("./custom/components/lazysizes");
require("./custom/components/map");
require("./custom/components/carbon-badge");

app.init();
